//层级路由
export default [
    {
        id: '-1',
        path: '/home', //路由路径
        name: 'home', //name名称
        title: '首页', // 文本内容
        type: 'el-icon-folder', // icon类型
        disabled: true, //权限树中是否禁止操作
    },
    /*{
        id: '-2',
        path: '/usdt_daifu', //路由路径
        name: 'usdt_daifu', //name名称
        title: 'USDT代付', // 文本内容
        type: 'el-icon-folder', // icon类型
        disabled: true, //权限树中是否禁止操作
        hidden: true, //隐藏菜单
    },*/
    {
        id: '1000',
        path: '/index', //路由路径
        name: 'index', //name名称
        title: '数据统计', // 文本内容
        type: 'el-icon-folder', // icon类型
    },
    {
        id: '1',
        title: '支付管理',
        type: 'el-icon-folder',
        children: [{
            id: '1-1',
            path: '/payment',
            name: 'payment',
            title: '支付管理',
            type: 'el-icon-folder',
        }, {
            id: '1-2',
            path: '/payment_groups',
            name: 'payment_groups',
            title: '支付分组',
            type: 'el-icon-folder',
        }, {
            id: '1-3',
            path: '/cdkey',
            name: 'cdkey',
            title: 'CDkey管理',
            type: 'el-icon-folder',
        }, {
            id: '1-4',
            path: '/cdkey/:id',
            name: 'cdkey_details',
            title: 'cdkey详情',
            type: 'el-icon-folder',
            hidden: true, //隐藏菜单
        },]
    },
    {
        id: '2',
        title: '盒子管理',
        type: 'el-icon-folder',
        children: [{
            id: '2-1',
            path: '/case',
            name: 'case',
            title: '盒子管理',
            type: 'el-icon-folder',
        },
            {
                id: '2-2',
                path: '/case_sold_out',
                name: 'case_sold_out',
                title: '下架盒子',
                type: 'el-icon-folder',
            },
            {
                id: '2-3',
                path: '/box_group',
                name: 'box_group',
                title: '盒子分组',
                type: 'el-icon-folder',
            },
            {
                id: '2-4',
                path: '/category',
                name: 'category',
                title: '盒子分类',
                type: 'el-icon-folder',
            },
            {
                id: '2-5',
                title: '保底管理',
                type: 'el-icon-folder',
                children: [{
                    id: '2-5-1',
                    path: '/case_guaranteed_overview',
                    name: 'case_guaranteed_overview',
                    title: '保底总览',
                    type: 'el-icon-folder',
                },
                    {
                        id: '2-5-2',
                        path: '/case_coefficient_config',
                        name: 'case_coefficient_config',
                        title: '系数配置',
                        type: 'el-icon-folder',
                    },
                    {
                        id: '2-5-3',
                        path: '/case_guaranteed_config',
                        name: 'case_guaranteed_config',
                        title: '常规配置',
                        type: 'el-icon-folder',
                    },
                    {
                        id: '2-5-4',
                        path: '/case_guaranteed_pool_config',
                        name: 'case_guaranteed_pool_config',
                        title: '水池配置',
                        type: 'el-icon-folder',
                    },
                    {
                        id: '2-5-5',
                        path: '/user_guaranteed',
                        name: 'user_guaranteed',
                        title: '保底用户数据',
                        type: 'el-icon-folder',
                    },
                    {
                        id: '2-5-6',
                        path: '/case_guaranteed_box',
                        name: 'case_guaranteed_box',
                        title: '盒子盈亏',
                        type: 'el-icon-folder',
                    },
                    {
                        id: '2-5-7',
                        path: '/user_guaranteed_details',
                        name: 'user_guaranteed_details',
                        title: '保底用户数据详情',
                        type: 'el-icon-folder',
                        hidden: true, //隐藏菜单
                    },
                    {
                        id: '2-5-8',
                        path: '/case_guaranteed_box_details',
                        name: 'case_guaranteed_box_details',
                        title: '盒子盈亏详情',
                        type: 'el-icon-folder',
                        hidden: true, //隐藏菜单
                    },
                ]
            },
            {
                id: '2-6',
                path: '/case/:id',
                name: 'case_prize',
                title: '盒子奖品',
                type: 'el-icon-folder',
                hidden: true, //隐藏菜单
            },
            {
                id: '2-7',
                path: '/case_pv',
                name: 'case_pv',
                title: '隐藏盒子管理',
                type: 'el-icon-folder',
                hidden: true, //是否隐藏菜单
            },
            {
                id: '2-8',
                path: '/case_private/:id',
                name: 'case_private_details',
                title: '隐藏盒子详情',
                type: 'el-icon-folder',
                hidden: true, //是否隐藏菜单
            },
        ]
    },
    {
        id: '3',
        title: '奖品管理',
        type: 'el-icon-folder',
        children: [
            {
                id: '3-1',
                path: '/prize',
                name: 'prize',
                title: '奖品管理',
                type: 'el-icon-folder',
            },
            {
                id: '3-2',
                path: '/price_config',
                name: 'price_config',
                title: '价格配置',
                type: 'el-icon-folder',
            },
        ]
    },
    {
        id: '4',
        title: '商城管理',
        type: 'el-icon-folder',
        children: [{
            id: '4-1',
            path: '/shop',
            name: 'shop',
            title: '商城管理',
            type: 'el-icon-folder',
        },
            {
                id: '4-2',
                path: '/shop_record',
                name: 'shop_record',
                title: '商城购买记录',
                type: 'el-icon-folder',
            },
        ]
    },
    {
        id: '5',
        title: '用户管理',
        type: 'el-icon-folder',
        children: [{
            id: '5-1',
            path: '/user',
            name: 'user',
            title: '用户管理',
            type: 'el-icon-folder',
        },{
            id: '5-30',
            path: '/user_score_rule',
            name: 'user_score_rule',
            title: '用户等级分布',
            type: 'el-icon-folder',
        },
            {
                id: '5-30',
                path: '/user_anchor_stat',
                name: 'user_anchor_stat',
                title: '主播拉新',
                type: 'el-icon-folder',
            },
            {
                id: '5-2',
                path: '/user_benefit_statistical',
                name: 'user_benefit_statistical',
                title: '用户福利查询',
                type: 'el-icon-folder',
            },
            {
                id: '5-3',
                path: '/associated_real_name',
                name: 'associated_real_name',
                title: '用户关联',
                type: 'el-icon-folder',
            },
            {
                id: '5-21',
                path: '/associated_real_name_activity',
                name: 'associated_real_name_activity',
                title: '用户关联-活动币',
                type: 'el-icon-folder',
            },
            {
                id: '5-4',
                path: '/old_users',
                name: 'old_users',
                title: '老用户查询',
                type: 'el-icon-folder',
            },
            {
                id: '5-22',
                path: '/query_box',
                name: 'query_box',
                title: '箱子查询',
                type: 'el-icon-folder',
            },
            {
                id: '5-5',
                path: '/activity_mall_record',
                name: 'activity_mall_record',
                title: '活动币发放记录',
                type: 'el-icon-folder',
            },
            {
                id: '5-20',
                path: '/activity_mall_log',
                name: 'activity_mall_log',
                title: '活动币使用日志',
                type: 'el-icon-folder',
            },
            {
                id: '5-6',
                path: '/user_score_rule',
                name: 'user_score_rule',
                title: '等级积分规则',
                type: 'el-icon-folder',
            },
            {
                id: '5-7',
                path: '/user_exp_rule',
                name: 'user_exp_rule',
                title: '等级经验规则',
                type: 'el-icon-folder',
            },
            {
                id: '5-8',
                path: '/settlements',
                name: 'settlements',
                title: '渠道提现',
                type: 'el-icon-folder',
            },
            {
                id: '5-9',
                path: '/user_level_merge',
                name: 'user_level_merge',
                title: '等级合并',
                type: 'el-icon-folder',
            },
            {
                id: '5-10',
                path: '/account_balance_record',
                name: 'account_balance_record',
                title: '余额日志记录',
                type: 'el-icon-folder',
            },
            {
                id: '5-11',
                title: '用户禁止操作管理',
                type: 'el-icon-folder',
                children: [{
                    id: '5-11-1',
                    path: '/user_forbid',
                    name: 'user_forbid',
                    title: '用户禁止操作',
                    type: 'el-icon-folder',
                },
                    {
                        id: '5-11-2',
                        path: '/user_forbid_recharge',
                        name: 'user_forbid_recharge',
                        title: '黑名单禁止充值',
                        type: 'el-icon-folder',
                    }
                ]
            },
            {
                id: '5-12',
                path: '/water_control',
                name: 'water_control',
                title: '战力查看',
                type: 'el-icon-folder',
            },
            {
                id: '5-13',
                path: '/user_ip_logs',
                name: 'user_ip_logs',
                title: 'IP查询',
                type: 'el-icon-folder',
            },
            {
                id: '5-14',
                path: '/user_anchors',
                name: 'user_anchors',
                title: '主播下级管理',
                type: 'el-icon-folder',
            },
            {
                id: '5-15',
                path: '/user_sign_in',
                name: 'user_sign_in',
                title: '用户签到设置',
                type: 'el-icon-folder',
            },
            {
                id: '5-16',
                title: '交易链接封禁',
                type: 'el-icon-folder',
                children: [{
                    id: '5-16-1',
                    path: '/user_transaction_link',
                    name: 'user_transaction_link',
                    title: '交易链接封禁',
                    type: 'el-icon-folder',
                }, {
                    id: '5-16-2',
                    path: '/user_transaction_query',
                    name: 'user_transaction_query',
                    title: '交易链接查询',
                    type: 'el-icon-folder',
                }, {
                    id: '5-16-3',
                    path: '/user_transaction_unseal',
                    name: 'user_transaction_unseal',
                    title: 'ig链接解封',
                    type: 'el-icon-folder',
                }]
            },
            {
                id: '5-17',
                path: '/user_limit_consumption',
                name: 'user_limit_consumption',
                title: '用户限制消费',
                type: 'el-icon-folder',
            },
            {
                id: '5-18',
                path: '/add_anchor',
                name: 'add_anchor',
                title: '设置主播',
                type: 'el-icon-folder',
            },
            {
                id: '5-23',
                path: '/customer_service',
                name: 'customer_service',
                title: '专属客服',
                type: 'el-icon-folder',
            },
            {
                id: '5-24',
                path: '/query_real_name',
                name: 'query_real_name',
                title: '实名认证',
                type: 'el-icon-folder',
            },
            {
                id: '5-25',
                path: '/face_recognition',
                name: 'face_recognition',
                title: '人脸识别限制',
                type: 'el-icon-folder',
            },
            {
                id: '5-26',
                path: '/extract_m9',
                name: 'extract_m9',
                title: 'M9提取记录',
                type: 'el-icon-folder',
            },
            {
                id: '5-19',
                path: '/user/:id',
                name: 'user_details',
                title: '用户详情',
                type: 'el-icon-folder',
                hidden: true, //隐藏菜单
            },
            {
                id: '5-27',
                path: '/transfer',
                name: 'transfer',
                title: '转赠',
                type: 'el-icon-folder',
            }
        ]
    },
    {
        id: '6',
        title: '订单管理',
        type: 'el-icon-folder',
        children: [{
            id: '6-1',
            path: '/order',
            name: 'order',
            title: '取回/出售订单',
            type: 'el-icon-folder',
        },
            {
                id: '6-5',
                path: '/shop_order',
                name: 'shop_order',
                title: '商城订单',
                type: 'el-icon-folder',
            },
            {
                id: '6-2',
                path: '/raffle',
                name: 'raffle',
                title: '购买订单',
                type: 'el-icon-folder',
            },
            {
                id: '6-3',
                path: '/goods_order',
                name: 'goods_order',
                title: '商品订单',
                type: 'el-icon-folder',
            },
            {
                id: '6-4',
                path: '/recharge',
                name: 'recharge',
                title: '充值订单',
                type: 'el-icon-folder',
            },
            {
                id: '6-6',
                path: '/transaction_link_orders',
                name: 'transaction_link_orders',
                title: '交易链接订单',
                type: 'el-icon-folder',
            },
            {
                id: '6-7',
                path: '/automatic_delivery',
                name: 'automatic_delivery',
                title: '自动发货管理',
                type: 'el-icon-folder',
            },
        ]
    },
    {
        id: '7',
        title: 'ROLL房管理',
        type: 'el-icon-folder',
        children: [{
            id: '7-1',
            path: '/roll',
            name: 'roll',
            title: 'ROLL房管理',
            type: 'el-icon-folder',
        },
            {
                id: '7-2',
                path: '/roll_activity',
                name: 'roll_activity',
                title: 'ROLL房活动管理',
                type: 'el-icon-folder',
            },
            {
                id: '7-3',
                path: '/roll/:id',
                name: 'roll_details',
                title: 'roll房详情',
                type: 'el-icon-folder',
                hidden: true, //隐藏菜单
            },
            {
                id: '7-4',
                path: '/roll_activity/:id',
                name: 'roll_prize',
                title: 'ROLL房活动奖品',
                type: 'el-icon-folder',
                hidden: true, //隐藏菜单
            },
        ]
    },
    {
        id: '8',
        title: '热血盲盒管理',
        type: 'el-icon-folder',
        children: [{
            id: '8-1',
            path: '/battle_manage',
            name: 'battle_manage',
            title: '热血盲盒管理',
            type: 'el-icon-folder',
        },
            {
                id: '8-2',
                path: '/random_box',
                name: 'random_box',
                title: '随机盒子配置',
                type: 'el-icon-folder',
            },
            {
                id: '8-3',
                path: '/blind_seeds',
                name: 'blind_seeds',
                title: '对战种子',
                type: 'el-icon-folder',
            },
            {
                id: '8-4',
                path: '/random_room_log',
                name: 'random_room_log',
                title: '随机房间记录',
                type: 'el-icon-folder',
            },
            {
                id: '8-5',
                path: '/battle_user_data',
                name: 'battle_user_data',
                title: '用户数据',
                type: 'el-icon-folder',
            },
            {
                id: '8-6',
                path: '/battle_room_data',
                name: 'battle_room_data',
                title: '房间数据',
                type: 'el-icon-folder',
            },
            {
                id: '8-7',
                path: '/battle_box_data',
                name: 'battle_box_data',
                title: '盒子数据',
                type: 'el-icon-folder',
            },
            {
                id: '8-8',
                path: '/battle_caton_room',
                name: 'battle_caton_room',
                title: '卡顿房间',
                type: 'el-icon-folder',
            },
        ]
    },
    {
        id: '18',
        title: '盒子/饰品升级',
        type: 'el-icon-folder',
        children: [
            {
                id: '18-1',
                path: '/upgrade_boxList',
                name: 'upgrade_boxList',
                title: '盒子列表(升级)',
                type: 'el-icon-folder',
            },
            {
                id: '18-2',
                path: '/upgrade_details',
                name: 'upgrade_details',
                title: '详情升级情况',
                type: 'el-icon-folder',
            },
            {
                id: '18-3',
                path: '/upgrade_box_data',
                name: 'upgrade_box_data',
                title: '盒子数据(升级)',
                type: 'el-icon-folder',
            },
            {
                id: '18-4',
                path: '/upgrade_user_data',
                name: 'upgrade_user_data',
                title: '用户数据(升级)',
                type: 'el-icon-folder',
            },
            {
                id: '18-5',
                path: '/upgrade_guaranteed_goods',
                name: 'upgrade_guaranteed_goods',
                title: '保底饰品(升级)',
                type: 'el-icon-folder',
            },
        ]
    },
    {
        id: '9',
        title: '战团管理',
        type: 'el-icon-folder',
        children: [{
            id: '9-1',
            path: '/battle_groups',
            name: 'battle_groups',
            title: '战团管理',
            type: 'el-icon-folder',
        },
            {
                id: '9-2',
                path: '/battle_user',
                name: 'battle_user',
                title: '成员列表',
                type: 'el-icon-folder',
            },
            {
                id: '9-3',
                path: '/battle_bonus',
                name: 'battle_bonus',
                title: '战团配置',
                type: 'el-icon-folder',
            },
            {
                id: '9-4',
                path: '/battle_objective',
                name: 'battle_objective',
                title: '宗旨审核',
                type: 'el-icon-folder',
            },
            {
                id: '9-5',
                path: '/integral_goods',
                name: 'integral_goods',
                title: '积分商品',
                type: 'el-icon-folder',
            },
        ]
    },
    {
        id: '19',
        title: '优惠券管理',
        type: 'el-icon-folder',
        children: [{
            id: '19-1',
            path: '/coupon',
            name: 'coupon',
            title: '优惠券配置',
            type: 'el-icon-folder',
        }, {
            id: '19-2',
            path: '/coupon_log',
            name: 'coupon_log',
            title: '优惠券记录',
            type: 'el-icon-folder',
        }
        ]
    },
    {
        id: '10',
        title: '会员卡管理',
        type: 'el-icon-folder',
        children: [{
            id: '10-1',
            path: '/vip_card',
            name: 'vip_card',
            title: '会员卡配置',
            type: 'el-icon-folder',
        },
            {
                id: '10-2',
                path: '/vip_user',
                name: 'vip_user',
                title: '会员用户表',
                type: 'el-icon-folder',
            },
            {
                id: '10-3',
                path: '/vip_log',
                name: 'vip_log',
                title: '会员卡领取记录',
                type: 'el-icon-folder',
            },
        ]
    },
    {
        id: '11',
        title: '福利中心',
        type: 'el-icon-folder',
        children: [{
            id: '11-1',
            title: '任务管理',
            type: 'el-icon-folder',
            children: [{
                id: '11-1-1',
                path: '/task',
                name: 'task',
                title: '任务管理',
                type: 'el-icon-folder',
            }, {
                id: '11-1-2',
                path: '/task_log',
                name: 'task_log',
                title: '任务领取记录',
                type: 'el-icon-folder',
            },
            ]
        },
            {
                id: '11-2',
                path: '/new_user_recharge',
                name: 'new_user_recharge',
                title: '新人充值管理',
                type: 'el-icon-folder',
            },
        ]
    },
    {
        id: '12',
        path: '/repair_order',
        name: 'repair_order',
        title: '工单管理',
        type: 'el-icon-folder',
    },
    {
        id: '13',
        title: '消息/文案管理',
        type: 'el-icon-folder',
        children: [
            {
                id: '13-6',
                path: '/system_mail',
                name: 'system_mail',
                title: '站内消息',
                type: 'el-icon-folder',
            },
            {
                id: '13-1',
                path: '/message',
                name: 'message',
                title: '网站公告',
                type: 'el-icon-folder',
            },
            {
                id: '13-2',
                path: '/article',
                name: 'article',
                title: '文章管理',
                type: 'el-icon-folder',
            },
            {
                id: '13-3',
                path: '/article/create',
                name: 'article_create',
                title: '新建文章',
                type: 'el-icon-folder',
                hidden: true, //隐藏菜单
            },
            {
                id: '13-4',
                path: '/article/edit/:article_id',
                name: 'article_edit',
                title: '编辑文章',
                type: 'el-icon-folder',
                hidden: true, //隐藏菜单
            },
            {
                id: '13-5',
                path: '/article/detail/:article_id',
                name: 'article_detail',
                title: '文章详情',
                type: 'el-icon-folder',
                hidden: true, //隐藏菜单
            },
            {
                id: '13-7',
                path: '/system_mail_detail/:id',
                name: 'system_mail_detail',
                title: '站内消息详情',
                type: 'el-icon-folder',
                hidden: true, //隐藏菜单
            },
        ]
    },
    {
        id: '14',
        title: '红包管理',
        type: 'el-icon-folder',
        children: [{
            id: '14-1',
            path: '/password_red_packet',
            name: 'password_red_packet',
            title: '口令红包',
            type: 'el-icon-folder',
        },
            {
                id: '14-2',
                path: '/inherit_red_envelope',
                name: 'inherit_red_envelope',
                title: '继承红包',
                type: 'el-icon-folder',
            },
            {
                id: '14-3',
                path: '/welfare_red_envelope',
                name: 'welfare_red_envelope',
                title: '福利红包',
                type: 'el-icon-folder',
            },
            {
                id: '14-4',
                path: '/red_envelope_editor',
                name: 'red_envelope_editor',
                title: '红包编辑',
                type: 'el-icon-folder',
            },
            {
                id: '14-5',
                path: '/accumulated_topup_conditions',
                name: 'accumulated_topup_conditions',
                title: '累充红包条件',
                type: 'el-icon-folder',
            },
            {
                id: '14-6',
                path: '/password_packets/:id',
                name: 'password_packets_details',
                title: '口令列表',
                type: 'el-icon-folder',
                hidden: true, //隐藏菜单
            },
        ]
    },
    {
        id: '15',
        title: '活动管理',
        type: 'el-icon-folder',
        children: [{
            id: '15-1',
            title: '转盘活动',
            type: 'el-icon-folder',
            children: [{
                id: '15-1-1',
                path: '/rotary_activities_config',
                name: 'rotary_activities_config',
                title: '转盘活动配置',
                type: 'el-icon-folder',
            },
                {
                    id: '15-1-2',
                    path: '/rotary_activities',
                    name: 'rotary_activities',
                    title: '转盘中奖记录',
                    type: 'el-icon-folder',
                },
                {
                    id: '15-1-3',
                    path: '/rotary_activities_rank',
                    name: 'rotary_activities_rank',
                    title: '转盘排行榜',
                    type: 'el-icon-folder',
                },
            ]
        },
            {
                id: '15-2',
                title: '端午活动',
                type: 'el-icon-folder',
                children: [{
                    id: '15-2-1',
                    path: '/dragon_boat_config',
                    name: 'dragon_boat_config',
                    title: '端午活动配置',
                    type: 'el-icon-folder',
                },]
            },
            {
                id: '15-3',
                title: '碎片活动',
                type: 'el-icon-folder',
                children: [{
                    id: '15-3-1',
                    path: '/debirs_group',
                    name: 'debirs_group',
                    title: '碎片分组',
                    type: 'el-icon-folder',
                },
                    {
                        id: '15-3-2',
                        path: '/debris_config',
                        name: 'debris_config',
                        title: '碎片配置',
                        type: 'el-icon-folder',
                    },
                    {
                        id: '15-3-3',
                        path: '/debris_formula_config',
                        name: 'debris_formula_config',
                        title: '公式配置',
                        type: 'el-icon-folder',
                    },
                    {
                        id: '15-3-4',
                        path: '/debris_box_config',
                        name: 'debris_box_config',
                        title: '碎片盒子配置',
                        type: 'el-icon-folder',
                    },
                ]
            },
            {
                id: '15-4',
                title: '秒杀活动',
                type: 'el-icon-folder',
                children: [{
                    id: '15-4-1',
                    path: '/seckill',
                    name: 'seckill',
                    title: '秒杀管理',
                    type: 'el-icon-folder',
                },]
            },
            {
                id: '15-5',
                title: '战队投票',
                type: 'el-icon-folder',
                children: [{
                    id: '15-5-1',
                    path: '/voting_quiz',
                    name: 'voting_quiz',
                    title: '投票管理',
                    type: 'el-icon-folder',
                },]
            },
            {
                id: '15-6',
                title: '眉笔活动',
                type: 'el-icon-folder',
                children: [
                    {
                        id: '15-6-1',
                        path: '/unluck_battle_config',
                        name: 'unluck_battle_config',
                        title: '热血盲盒眉笔',
                        type: 'el-icon-folder',
                    },
                    // {
                    //   id: '15-6-2',
                    //   path: '/unluck_upgrade_config',
                    //   name: 'unluck_upgrade_config',
                    //   title: '幸运升级眉笔',
                    //   type: 'el-icon-folder',
                    // },
                ]
            },
            {
                id: '15-7',
                title: '推广活动',
                type: 'el-icon-folder',
                children: [
                    {
                        id: '15-7-1',
                        path: '/partner_config',
                        name: 'partner_config',
                        title: '推广活动配置',
                        type: 'el-icon-folder',
                    },
                    {
                        id: '15-7-2',
                        path: '/partner_prize',
                        name: 'partner_prize',
                        title: '推广活动奖品',
                        type: 'el-icon-folder',
                    },
                ]
            },
            {
                id: '15-8',
                title: '新年活动',
                type: 'el-icon-folder',
                children: [
                    {
                        id: '15-8-1',
                        path: '/new_year_config',
                        name: 'new_year_config',
                        title: '新年活动配置',
                        type: 'el-icon-folder',
                    },
                ]
            },
        ]
    },
    {
        id: '16',
        title: '头像/名字管理',
        type: 'el-icon-folder',
        children: [{
            id: '16-1',
            path: '/examine_avatar',
            name: 'examine_avatar',
            title: '头像管理',
            type: 'el-icon-folder',
        },
            {
                id: '16-2',
                path: '/examine_name',
                name: 'examine_name',
                title: '名字审核',
                type: 'el-icon-folder',
            },
        ]
    },
    {
        id: '17',
        title: '数据统计',
        type: 'el-icon-folder',
        children: [{
            id: '17-1',
            path: '/recharge_statistic',
            name: 'recharge_statistic',
            title: '充值统计',
            type: 'el-icon-folder',
        },
            {
                id: '17-2',
                path: '/retrieve_or_shop_statistic',
                name: 'retrieve_or_shop_statistic',
                title: '取回/商城统计',
                type: 'el-icon-folder',
            },
            {
                id: '17-3',
                path: '/lottery_statistic',
                name: 'lottery_statistic',
                title: '抽奖统计',
                type: 'el-icon-folder',
            },
            {
                id: '17-4',
                path: '/battle_statistics',
                name: 'battle_statistics',
                title: '对战统计',
                type: 'el-icon-folder',
            },
            {
                id: '17-5',
                path: '/user_statistic',
                name: 'user_statistic',
                title: '用户查询',
                type: 'el-icon-folder',
            },
        ]
    },
    {
        id: '998',
        path: '/config',
        name: 'config',
        title: 'qq群与客服配置',
        type: 'el-icon-folder',
        hidden: true, //隐藏菜单
    },
    {
        id: '999',
        title: '权限管理',
        type: 'el-icon-folder',
        children: [{
            id: '999-1',
            path: '/permission',
            name: 'permission',
            title: '权限管理',
            type: 'el-icon-folder',
        },
            {
                id: '999-2',
                path: '/action_log',
                name: 'action_log',
                title: '行为日志',
                type: 'el-icon-folder',
            },
        ]
    }
]
